<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">{{ el.qiShu }}期澳门码神一肖一码大公开</div>
        <div class="value">
          <div class="code">
            <span>特码</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>一肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx1"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>三肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx3"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>五肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx5"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>七肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx7"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>九肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx9"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="!el.ifZuiXin" class="kaijiang">
          开 {{ el.code }} {{ el.shengXiao }}
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #b4b9b1, #f1edeb);
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      //   padding: 5px 12px;
      padding: 0;
      font-weight: bold;
      //   display: flex;
      justify-content: center;
      .qi {
        border-bottom: 1px solid #ccc;
        padding: 6px 0;
        background-color: #0d35f4;
        color: #fff;
      }
      .value {
        color: red;
        > div {
          border-bottom: 1px solid #ccc;
          display: flex;
          > span {
            width: 15%;
            border-right: 1px solid #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1d1df5;
          }
          > div {
            padding: 6px 12px;
            display: flex;
            flex-wrap: wrap;
            grid-gap: 12px;
            flex: 1;
            color: #333;
            .win {
              color: red;
              background-color: #fcfb04;
              font-size: 120%;
            }
          }
        }
      }
      .kaijiang{
        padding: 6px 0;
        background-color: #b2ae32;
        color: red;
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>